export default __webpack_public_path__ + "static/media/logoname.48cf0352.png";